import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex h-full w-full flex-col" }
const _hoisted_2 = ["data-state", "data-collapsible", "data-variant", "data-side"]
const _hoisted_3 = {
  "data-sidebar": "sidebar",
  class: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:shadow-sm"
}

import type { SidebarProps } from '.'
import { cn } from '@/lib/utils'
import { Sheet, SheetContent } from '@/components/ui/sheet'
import SheetDescription from '@/components/ui/sheet/SheetDescription.vue'
import SheetHeader from '@/components/ui/sheet/SheetHeader.vue'
import SheetTitle from '@/components/ui/sheet/SheetTitle.vue'
import { SIDEBAR_WIDTH_MOBILE, useSidebar } from './utils'


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false
},
  __name: 'Sidebar',
  props: {
    side: { default: 'left' },
    variant: { default: 'sidebar' },
    collapsible: { default: 'offcanvas' },
    class: {}
  },
  setup(__props: any) {



const props = __props

const { isMobile, state, openMobile, setOpenMobile } = useSidebar()

return (_ctx: any,_cache: any) => {
  return (_ctx.collapsible === 'none')
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        "data-slot": "sidebar",
        class: _unref(cn)('bg-sidebar text-sidebar-foreground flex w-(--sidebar-width) flex-col', props.class)
      }, _ctx.$attrs), [
        _renderSlot(_ctx.$slots, "default")
      ], 16))
    : (_unref(isMobile))
      ? (_openBlock(), _createBlock(_unref(Sheet), _mergeProps({
          key: 1,
          open: _unref(openMobile)
        }, _ctx.$attrs, { "onUpdate:open": _unref(setOpenMobile) }), {
          default: _withCtx(() => [
            _createVNode(_unref(SheetContent), {
              "data-sidebar": "sidebar",
              "data-slot": "sidebar",
              "data-mobile": "true",
              side: _ctx.side,
              class: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
              style: _normalizeStyle({
        '--sidebar-width': _unref(SIDEBAR_WIDTH_MOBILE)
      })
            }, {
              default: _withCtx(() => [
                _createVNode(SheetHeader, { class: "sr-only" }, {
                  default: _withCtx(() => [
                    _createVNode(SheetTitle, null, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode("Sidebar")
                      ])),
                      _: 1,
                      __: [0]
                    }),
                    _createVNode(SheetDescription, null, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode("Displays the mobile sidebar.")
                      ])),
                      _: 1,
                      __: [1]
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "default")
                ])
              ]),
              _: 3
            }, 8, ["side", "style"])
          ]),
          _: 3
        }, 16, ["open", "onUpdate:open"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "group peer text-sidebar-foreground hidden md:block",
          "data-slot": "sidebar",
          "data-state": _unref(state),
          "data-collapsible": _unref(state) === 'collapsed' ? _ctx.collapsible : '',
          "data-variant": _ctx.variant,
          "data-side": _ctx.side
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(
        _unref(cn)(
          'relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear',
          'group-data-[collapsible=offcanvas]:w-0',
          'group-data-[side=right]:rotate-180',
          _ctx.variant === 'floating' || _ctx.variant === 'inset'
            ? 'group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]'
            : 'group-data-[collapsible=icon]:w-(--sidebar-width-icon)'
        )
      )
          }, null, 2),
          _createElementVNode("div", _mergeProps({
            class: 
        _unref(cn)(
          'fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex',
          _ctx.side === 'left'
            ? 'left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]'
            : 'right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]',
          // Adjust the padding for floating and inset variants.
          _ctx.variant === 'floating' || _ctx.variant === 'inset'
            ? 'p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]'
            : 'group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l',
          props.class
        )
      
          }, _ctx.$attrs), [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ], 16)
        ], 8, _hoisted_2))
}
}

})